/**
 * Read TAR file (UStar format, POSIX IEEE P1003.1). Partial Implementation (list files + file content accessor)
 * @class TarReader
 * @see https://en.wikipedia.org/wiki/Tar_%28computing%29
 * @see http://www.cs.usfca.edu/~benson/cs326/pintos/pintos/src/lib/ustar.c
 * @see http://www.fileformat.info/format/tar/corion.htm
 */

function TarReader(){
	this.files = [];
}

TarReader.BLOCK_SIZE = 512;

/*
 Metadata positions and size, relative to begin of each record
 */
// header[512]= 100/*name*/ + 8/*mode*/ + 8/*uid*/ + 8/*gid*/ + 12/*size*/ + 12/*mtime*/ + 8/*checksum*/ + 1/*typeflag*/ + 100/*linkname*/ + 6/*magic*/ + 2/*version*/ + 32/*uname*/ + 32/*gname*/ + 8/*devmajor*/ + 8/*devminor*/ + 155/*prefix*/ + 12/*pad*/

// Name
TarReader.NAME_OFFSET = 0;
TarReader.NAME_SIZE = 100;
// Type
TarReader.TYPE_OFFSET = 100/*name*/ + 8/*mode*/ + 8/*uid*/ + 8/*gid*/ + 12/*size*/ + 12/*mtime*/ + 8/*checksum*/;
TarReader.TYPE_SIZE = 1;
// Size (content)
TarReader.SIZE_OFFSET = 100/*name*/ + 8/*mode*/ + 8/*uid*/ + 8/*gid*/;
TarReader.SIZE_SIZE = 12;
// Magic
TarReader.MAGIC_OFFSET = 100/*name*/ + 8/*mode*/ + 8/*uid*/ + 8/*gid*/ + 12/*size*/ + 12/*mtime*/ + 8/*checksum*/ + 1/*typeflag*/ + 100/*linkname*/;
TarReader.MAGIC_SIZE = 6;
// Prefix
TarReader.PREFIX_OFFSET = 100/*name*/ + 8/*mode*/ + 8/*uid*/ + 8/*gid*/ + 12/*size*/ + 12/*mtime*/ + 8/*checksum*/ + 1/*typeflag*/ + 100/*linkname*/ + 6/*magic*/ + 2/*version*/ + 32/*uname*/ + 32/*gname*/ + 8/*devmajor*/ + 8/*devminor*/;
TarReader.PREFIX_SIZE = 155;

TarReader.TYPE_FILE = "0";// = 0x30 could be also 0x0 (null char)
TarReader.TYPE_DIR = "5";// = 0x35
/**
 * All strings are in ASCII.
 */
TarReader.prototype._readString = function _readString(buffer, offset, length){
	var value = "";
	var data = new Uint8Array(buffer, offset, length);
	var charCode;
	for(var index = 0; index < length; index++){
		charCode = data[index];
		// Null char (skip it)
		if(charCode == 0){
			break;
		}
		value += String.fromCharCode(charCode);
	}
	return value;
};
TarReader.prototype._readNumber = function _readNumber(buffer, offset, length){
	var raw = this._readString(buffer, offset, length);
	// Empty string means value 0 (not NaN)
	if(raw === ""){
		return 0;
	}
	return parseInt(raw, 8/*string number using octal notation*/);
};

/** @type {Array.<TarReaderFile>} */
TarReader.prototype.files = null;
/**
 * @type {ArrayBuffer}
 */
TarReader.prototype._buffer = null;
TarReader.prototype._offset = 0;
TarReader.prototype._endOfRecords = false;
/**
 * Read bytes of TAR stream/file
 * @param {ArrayBuffer} buffer Bytes of TAR stream (from the begin of stream)
 * TODO support append mode as default (not supported yet)
 */
TarReader.prototype.readChunk = function readChunk(buffer){
	this._buffer = buffer;
	// Simplify property lookup
	var offset = this._offset;
	var blockSize = TarReader.BLOCK_SIZE;
	var numBytes = buffer.byteLength;

	var type;
	var dataSize;
	var dataSizePadded;
	var name;
	var magic;
	var prefix;
	var fullname;
	var firstEndRecord = false;

	// Stream already ended
	if(this._endOfRecords){
		return;
	}

	// Record explorer
	// Will read only metadata, if enouth data to read it
	while(offset + blockSize <= numBytes){
//		console.log("Record @0x"+offset.toString(16));
		/*
		 struct header_posix_ustar {
		 char	name[100];
		 char	mode[8];
		 char	uid[8];
		 char	gid[8];
		 char	size[12];
		 char	mtime[12];
		 char	checksum[8];
		 char	typeflag[1];
		 char	linkname[100];
		 char	magic[6];
		 char	version[2];
		 char	uname[32];
		 char	gname[32];
		 char	devmajor[8];
		 char	devminor[8];
		 char	prefix[155];
		 char	pad[12];
		 };
		 */

		type = this._readString(buffer, offset + TarReader.TYPE_OFFSET, TarReader.TYPE_SIZE) || "0";

		dataSize = this._readNumber(buffer, offset + TarReader.SIZE_OFFSET, TarReader.SIZE_SIZE);

		if(isNaN(dataSize)){
			throw "Not a octal number! @0x" + offset.toString(16);
		}

		// Tar pad data to block of 512 bytes
		// Size for TarReader.TYPE_FOLDER is total size of its content, other type except should have `size == 0`
		dataSizePadded = type == TarReader.TYPE_FILE ? Math.ceil(dataSize / blockSize) * blockSize : 0;

		// Wait if there not enough data to read full record (header + padded data)
		if(offset + blockSize + dataSizePadded > numBytes){
			// Wait an other chunk of bytes to complete it
			break;
		}

		name = this._readString(buffer, offset + TarReader.NAME_OFFSET, TarReader.NAME_SIZE);

		/**
		 * TAR stream should ended by 2 empty records
		 */
		if(name == "" && type == TarReader.TYPE_FILE /* && dataSize == 0*/){
			if(firstEndRecord){
				this._endOfRecords = true;
				break;
			}
			firstEndRecord = true;
			offset += blockSize;
			continue;
			// Next should be an other endrecord
		}else if(firstEndRecord){
			// Previous record was useless record
			firstEndRecord = false;
		}

		magic = this._readString(buffer, offset + TarReader.MAGIC_OFFSET, TarReader.MAGIC_SIZE);

		// http://sourceforge.net/p/sevenzip/discussion/45797/thread/1815e053#cb34
		// http://pear.php.net/bugs/bug.php?id=12462
		if(magic === "ustar " || magic === "ustar  " || magic === "ustar"){
			prefix = this._readString(buffer, offset + TarReader.PREFIX_OFFSET, TarReader.PREFIX_SIZE);
			// Add trailing slash if missing (only if there is a directory to prefix)
			if(prefix.length > 0 && prefix.charAt(prefix.length -1) != "/"){
				prefix += "/";
			}
			fullname = prefix + name;
			// If folder and not end by trailing slash
			if(type == TarReader.TYPE_DIR && fullname.charAt(fullname.length -1) != "/"){
				fullname += "/";
			}

			switch(type){
				case TarReader.TYPE_FILE:
					var start = offset + blockSize;
					this.files.push(new TarReaderFile(fullname, TarReaderFile.TYPE_FILE, buffer.slice(start, start + dataSize)));
					break;
//				case TarReader.TYPE_DIR:
//					data = [/*TODO add files?*/];
//					this.files.push(new TarReaderFile(fullname, TarReaderFile.TYPE_DIR, data));
//					break;
			}
		}else{
			console.log("Warning! Unsupported TAR record type:\"" + type + "\", name:\"" + name + "\", magic:\"" + magic + "\", size:\"" + dataSize + "\"");
		}


		// Goto next record: header + padded data
		offset += blockSize + dataSizePadded;
	}
	// Else wait an other chunk of bytes (if any)

	// Save offset
	this._offset = offset;

};
/**
 * @type {Array.<TarReaderFile>}
 */
TarReader.prototype.files = null;

/**
 * @class TarReaderFile
 */
function TarReaderFile(name, type, data){
	this.name = name;
	this.type = type;
	this.data = data;
}
TarReaderFile.TYPE_FILE = 0x1;
TarReaderFile.TYPE_DIR = 0x2;
//TODO hard and symlinks. Data will be TarReaderFile instance or string filename

/**
 * @type {String}
 */
TarReaderFile.prototype.name = null;
/**
 * @type {String}
 */
TarReaderFile.prototype.type = null;
/**
 * @type {ArrayBuffer|String}
 */
TarReaderFile.prototype.data = null;